import { Fields } from "../../../FieldNames";
import { getFieldLabelId } from "../../../../helpers/contentTypeLabelId";
import { DateMetaData, FieldType } from "../../../../types/ContentType/fields";
export var modifiedMetaDateField = {
  type: FieldType.MetaDate,
  name: Fields.MODIFIED,
  labelId: getFieldLabelId(Fields.MODIFIED),
  metaDataField: DateMetaData.Modified
};